/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "components/Grid";
import { Field, Form, Formik } from "formik";
import {
  GridColumnTitle,
  InputField,
  Label,
  CheckBox,
  Button,
  ComboBox,
  DateRangePicker
} from "@fitinsur/components";
import {
  RowOrderFilter,
  CalendarContainer,
  MobileLabel,
  FilterSearchContainer,
  RowFilterIcon,
  FilterContainer,
  RowFilter,
  CheckBoxColumn,
  FilterColumn,
  ColIcon,
  RowOrderFilterMobile,
  Line,
  TableHead,
  TableRow,
  TableHeader
} from "./styles";

import Icon from "components/Icon";
import { GlobalAuthContext } from "store/context";

const ListHeader = ({ exportList, ...props }) => {
  const [showCalendar, setShowCalendar] = useState("");
  const formik = useRef(null);
  const authContext = useContext(GlobalAuthContext);
  const columns = props.columns;

  const initialValues = {};

  const [orderArrows, setOrderArrows] = useState({
  });

  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    props.formikRef(formik);
  }, [props]);

  const showRangeDate = (fieldKey) => {
    const from = formik.current?.values[fieldKey]?.from ? formik.current.values[fieldKey]?.from.toLocaleDateString("pt-BR") : "";
    const to = formik.current?.values[fieldKey]?.to ? formik.current.values[fieldKey]?.to.toLocaleDateString("pt-BR") : "";

    if (!from && !to) return ""
    return `${from} - ${to}`;
  };

  function resetFormikOrderParams(formikProps) {
    columns.map(column => formikProps.setFieldValue(column.key, null))
  }

  useEffect(() => {
    props.onShowFilter(showFilter)
  }, [props, showFilter])

  return (
    <Formik
      onSubmit={(values) => {
        props.updateFilter(values);
      }}
      initialValues={initialValues}
      innerRef={ref => {
        formik.current = ref;
        props.formikRef(formik)
      }}
      enableReinitialization={true}
    >
      {(formikProps) => {
        return (
          <Form>
            <RowFilterIcon>
              <FilterContainer
                className={showFilter ? "filter-open" : "filter-close"}
              >
                <Row>
                  <Col
                    style={{ display: "flex", justifyContent: "flex-end", padding: "5px 0 5px 0", }}
                  >
                    <Icon
                      name="close"
                      className="icon-close"
                      onClick={() => setShowFilter(false)}
                    />
                  </Col>
                </Row>
                <RowOrderFilterMobile>
                  <MobileLabel style={{ paddingBottom: '10px' }}>ORDER</MobileLabel>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {/* {OrderFilter(formikProps)} */}
                  </div>
                </RowOrderFilterMobile>
                <hr className="d-md-none mb-3" />
                <FilterSearchContainer>
                  <Row>
                    <MobileLabel>Filtro</MobileLabel>
                  </Row>

                  {columns.map(column => {
                    if (column.showFilter) {
                      return <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <CheckBox
                              onClick={() => {
                                formik.current.setFieldValue(column.fieldKey, "")
                                if (column.type === "calendar") {
                                  formik.current.setFieldValue('dateRangeTo', "");
                                  formik.current.setFieldValue('dateRangeFrom', "");
                                }
                              }}
                              checked={formikProps.values[column.fieldKey]}
                            />
                          </Label>
                        </CheckBoxColumn>
                        {column.type === "text" &&
                          <FilterColumn>
                            <Field
                              name={column.fieldKey}
                              placeholder={column.title}
                              value={formikProps.values[column.fieldKey]}
                              component={InputField}
                              type="text"
                              onChange={(e) => {
                                formikProps.setFieldValue(column.fieldKey, e);
                                console.log(formikProps.values);
                              }}
                              validation={false}
                              filterField={true}
                            />
                          </FilterColumn>}

                        {column.type === "calendar" &&
                          <FilterColumn>
                            <Field
                              name={column.fieldKey}
                              placeholder={column.title}
                              component={InputField}
                              rightIcon="calendar"
                              rightIconClick={() => {
                                setShowCalendar(!showCalendar ? column.key : "");
                              }}
                              validation={false}
                              customValue={showRangeDate(column.fieldKey)}
                              type="text"
                              readOnly
                              filterField={true}
                            />
                            {showCalendar === column.key && (
                              <CalendarContainer>
                                <DateRangePicker
                                  initialRange={{ from: formikProps.values[column.fieldKey]?.from, to: formikProps.values[column.fieldKey]?.to, }}
                                  onChange={(range) => {
                                    formikProps.setFieldValue(`${[column.fieldKey]}.from`, range.from);
                                    formikProps.setFieldValue(`${[column.fieldKey]}.to`, range.to);

                                    if (range.from && range.to) {
                                      setShowCalendar("");
                                      formikProps.setFieldValue(`dateRangeFrom`, range.from);
                                      formikProps.setFieldValue(`dateRangeTo`, range.to);
                                    }
                                  }}
                                />
                              </CalendarContainer>
                            )}
                          </FilterColumn>
                        }

                        {column.type === "list" &&
                          <FilterColumn>
                            <Field
                              name={column.fieldKey}
                              placeholder={column.title}
                              type="text"
                              component={ComboBox}
                              options={column.options || []}
                              validation={false}
                              value={formikProps.values[column.fieldKey]}
                              onChange={(e) => {
                                formikProps.setFieldValue(column.fieldKey, e);
                              }}
                              filter={true}
                              filterField={true}
                            />
                          </FilterColumn>}
                      </RowFilter>
                    }
                  })}
                </FilterSearchContainer>

                <Row
                  align="center"
                  className="apply-button-container"
                >
                  <Col>
                    <Button
                      primary
                      type="button"
                      id="btnFilter"
                      style={{ textAlign: "center" }}
                      onClick={(e) => {
                        setShowFilter(false);
                        formikProps.submitForm();
                      }}
                    >
                      Filtrar
                    </Button>
                  </Col>
                </Row>
              </FilterContainer>

              <ColIcon>
                <Icon
                  name="exportExcel"
                  onClick={() => exportList()}
                />
              </ColIcon>
              <ColIcon>
                <Icon
                  name="filter"
                  onClick={() => setShowFilter(!showFilter)}
                />
              </ColIcon>
              <ColIcon>
                <Icon
                  name="filterCan"
                  onClick={(e) => {
                    formikProps.resetForm(initialValues);
                    formikProps.submitForm(initialValues);
                  }}
                />
              </ColIcon>
            </RowFilterIcon>

            {/* <RowOrderFilter>{OrderFilter(formikProps)}</RowOrderFilter> */}
          </Form>
        );
      }}
    </Formik>
  );
};

export default ListHeader;
